import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/index.css";
import 'react-big-calendar/lib/css/react-big-calendar.css'

// layouts

import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// views without layouts
import Landing from "views/Landing.js";
import Profile from "views/Profile.js";
import PrivateRoute from "./routes/NormalUser";
import axios from "axios";
import { errorInterceptor, requestInterceptor, responseInterceptor } from "./store/helpers/common_functions";
import { configureStore } from "./store/configureStore";
import { Provider } from "react-redux";
import AuthRouteRedirect from "./routes/RedirectIfLoged";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import 'index.css';
import WorklogPersonalReport from "./views/admin/WorklogPersonalReport";
import {SocketProvider} from "helpers/SocketContext";

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

axios.interceptors.request.use(requestInterceptor);

axios.interceptors.response.use(responseInterceptor, errorInterceptor);

const store = configureStore();
ReactDOM.render(
  <Provider store={store}>
       <SocketProvider>
    <BrowserRouter>
 
      <Switch>
        {/* add routes with layouts */}

        <PrivateRoute path="/admin/worklog/profile/:id" component={WorklogPersonalReport} />
        <PrivateRoute path="/admin" component={Admin} />
        <AuthRouteRedirect path="/auth" component={Auth} />
        {/* add routes without layouts */}
        <PrivateRoute path="/landing" exact component={Landing} />
        {/*<Route path="/index" exact component={Index} />*/}
        <Route path="/" exact component={Landing} />
        {/* add redirect for first page */}
        <Redirect from="*" to="/" />
      </Switch>
     
    </BrowserRouter>
    </SocketProvider>
    </Provider>,
  document.getElementById("root")
);
